import '@angular/localize/init';
import 'zone.js';
// js-big-decimal fix
(window as any).global = window;
